import { Primary } from './Palettes/index.js';
/**
 * Palette shades approved for charts, in the design's order of use: LightBlue, PurpleBlue, Purple and
 * Teal in shade 100, then the same four in 30, then in 70, and Pink last in 100, 30 and 70.
 */
export const CHART_COLOR_KEYS = [
    'lightBlue100',
    'purpleBlue100',
    'purple100',
    'teal100',
    'lightBlue30',
    'purpleBlue30',
    'purple30',
    'teal30',
    'lightBlue70',
    'purpleBlue70',
    'purple70',
    'teal70',
    'pink100',
    'pink30',
    'pink70',
];
/**
 * The hex of a chart color. Charts look the same in the light and the dark theme, so this always reads the
 * light palette and never the active theme.
 */
export const chartColor = (key) => Primary.colors[key];
